import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import * as React from 'react';
import { ProductDetailOverlay } from '~shared/segments/ProductDetail';
import { useMenuScreenLayout } from '../../../screens/MenuScreen/hooks/useMenuScreenLayout';
import { useLayoutIsSM, useLayoutIsXS } from '../../Responsive/client';
import { ProductSoldOutNote } from './ProductSoldOutNote';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Screen-like component for product detail rendering.
 * Renders contexts (containing logic) and responsive content component (visuals).
 */
export var ProductDetail = function ProductDetail() {
  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      selectedLanguage = _useResolvedCompanyCt.selectedLanguage;

  var isMobile = useLayoutIsXS();
  var isNarrowScreen = useLayoutIsSM();

  var _useMenuScreenLayout = useMenuScreenLayout(),
      navigationAndCartStickyTopPx = _useMenuScreenLayout.navigationAndCartStickyTopPx;

  var _useResolvedCompanyCt2 = useResolvedCompanyCtx(),
      resolvedBranch = _useResolvedCompanyCt2.resolvedBranch;

  return /*#__PURE__*/_jsx(ProductDetailOverlay, {
    isMobile: isMobile,
    isTablet: isNarrowScreen,
    modalBodySpacing: "large",
    branchId: resolvedBranch.id,
    selectedLanguage: selectedLanguage,
    stuckContentHeight: navigationAndCartStickyTopPx,
    cannotOrderNote: /*#__PURE__*/_jsx(ProductSoldOutNote, {})
  });
};